var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_404",
    "data-name": "Rectangle 404",
    width: 20,
    height: 20,
    fill: "#c2e5f3",
    stroke: "#143359",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Call",
    transform: "translate(19097 9796)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_408",
    "data-name": "Rectangle 408",
    width: 24,
    height: 24,
    transform: "translate(-19097 -9796)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-phone-call",
    transform: "translate(-19095 -9794)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M10.84.833A.833.833,0,0,1,11.673,0a8.342,8.342,0,0,1,8.333,8.333.833.833,0,0,1-1.667,0,6.674,6.674,0,0,0-6.667-6.667A.833.833,0,0,1,10.84.833ZM11.673,5a3.333,3.333,0,0,1,3.333,3.333.833.833,0,0,0,1.667,0,5,5,0,0,0-5-5,.833.833,0,0,0,0,1.667Zm7.578,8.949a2.583,2.583,0,0,1,0,3.648l-.758.874C11.667,25.006-4.941,8.4,1.492,1.555L2.451.721A2.568,2.568,0,0,1,6.056.755c.026.026,1.57,2.032,1.57,2.032a2.583,2.583,0,0,1-.006,3.568L6.656,7.568a10.651,10.651,0,0,0,5.776,5.788l1.221-.971a2.583,2.583,0,0,1,3.568,0S19.225,13.923,19.25,13.949ZM18.1,15.161s-1.994-1.534-2.02-1.56a.917.917,0,0,0-1.291,0c-.022.023-1.7,1.362-1.7,1.362a.834.834,0,0,1-.816.127A12.507,12.507,0,0,1,4.923,7.75a.833.833,0,0,1,.121-.833s1.339-1.682,1.362-1.7a.917.917,0,0,0,0-1.291C6.38,3.9,4.846,1.9,4.846,1.9a.917.917,0,0,0-1.258.033l-.958.833c-4.7,5.653,9.691,19.248,14.645,14.566l.759-.875a.934.934,0,0,0,.071-1.3Z",
    transform: "translate(-0.006 0)",
    fill: "#c2e5f3",
    stroke: "#143359",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallFooter);
export default __webpack_public_path__ + "static/media/CallFooter.4251ce0bce38e9f6500403a9f32fcb72.svg";
export { ForwardRef as ReactComponent };